/**
 * Display text for a payment method read back off a receipt.
 *
 * Receipts persist the display label rather than a key, so the same method
 * appears under more than one string once the wording changes: a receipt
 * written before the card rename holds "Credit Card", one written after holds
 * "Card Payment". Resolving at render means historical receipts reprint and
 * report under the current wording instead of splitting into a second
 * category — no financial record is rewritten to achieve it.
 *
 * Anything unrecognised passes through untouched. The stored string is what was
 * actually recorded, and guessing a label for a value we don't know would be
 * worse than showing it as-is.
 *
 * The backend keeps its own copy at backend/src/utils/paymentMethodLabel.js —
 * frontend and backend are separate packages. Change both together.
 */
export const CARD_PAYMENT_LABEL = "Card Payment";

const CARD_ALIASES = new Set(["credit card", "creditcard", "card payment"]);

export function paymentMethodLabel(stored) {
  if (!stored) return "";
  const text = String(stored).trim();
  return CARD_ALIASES.has(text.toLowerCase()) ? CARD_PAYMENT_LABEL : text;
}
